import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./movingDetails.scss";

import { Col, Row } from "react-bootstrap";
import { LocationIcon } from "../../components/Icons";

const NonTruckingSavedAddress = (props) => {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const handleAddressSelection = (address) => {
    props.setLocationName(address.address);
    props.setSaveAddressModal(false);
  };

  return (
    <>
      <Modal
        show={props.saveAddressModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="z-3 position-relative"
          onClick={() => props.setSaveAddressModal(false)}
          closeButton
        >
          <Modal.Title>Saved address</Modal.Title>
        </Modal.Header>
        <Modal.Body className="z-1 position-relative">
          <Row className="g-3">
            {props.savedAddressList?.map((address) => (
              <Col md={6} key={address.id}>
                <div className="box-wrapper save-address-details  h-100">
                  <div className="save-address-info">
                    <div className="save-address">
                      <div>
                        <LocationIcon />
                      </div>
                      <div>{address.address}</div>
                    </div>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="savedAddress"
                      value={address.id}
                      checked={selectedAddress === address.id}
                      onChange={() => handleAddressSelection(address)}
                    />
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NonTruckingSavedAddress;
